import { UserPortfolioPosition } from '@Common/types/bo/users_portfolios';

export const portfolioPositionFields: Record<keyof UserPortfolioPosition, string> = {
  id: 'Instrument ID',
  stock_name: 'Company',
  symbol: 'Symbol',
  total_invested: 'Invested Amount',
  qty: 'Shares Owned',
  average_cost: 'Avg Cost',
  market_value_user_currency: 'Current Position Value',
  unrealized_plpc: 'Return (%)',
  total_gain: 'Total Gain',
  currency: 'Currency',
  average_cost_currency: 'Average cost currency',
  gain_loss: 'Gain / loss',
  fx_rate_impact: 'FX rate impact',
};

export const usersPortfolioTranslations = {
  fields: portfolioPositionFields,
};
